import type { ContactFormData, SubmitError } from './types';

/**
 * The three ways contact.php can refuse a submission, in this page's words.
 *
 * The legacy template said "Something's Doesn't Look Quite Right..." for all of them and
 * did not distinguish the captcha from a ticketing failure; the wording here is
 * DiscountMags' bulk order form's, which is the other V2 form posting to this endpoint.
 */
export const ERROR_MESSAGES: Record<NonNullable<SubmitError>, string> = {
  captcha: "We couldn't verify you're not a robot. Please try again.",
  ticket: 'An unexpected error occurred, please try again.',
  validation: 'Please fix the errors indicated below.',
};

/**
 * Each field's own message, as `jss_customer_fields.validationmessage` has it.
 *
 * One copy, used twice: the browser's rules quote it, and so does the mapping that puts a
 * server refusal back on the field it belongs to. `Subject`'s row carries the message and
 * the two spare rows do not, so `order` is absent here — it is the only optional field.
 */
export const FIELD_MESSAGES: Record<Exclude<keyof ContactFormData, 'order'>, string> = {
  name: 'Please enter your name',
  EmailAddress: 'Please enter a valid email address',
  Subject: 'Please select the subject',
  cfComments: 'Please enter your Message.',
};

/**
 * The per-field flags contact.php sets on a refusal, and the field each belongs to.
 *
 * Without this every server refusal read as "Please fix the errors indicated below" with
 * nothing indicated below — reachable whenever the server is stricter than the browser,
 * which it is: `chop()` before NOTBLANK rejects a name of spaces that `required` accepts,
 * and its email rule is tighter than the pattern here.
 */
export const SERVER_FIELD_ERRORS: Record<string, Exclude<keyof ContactFormData, 'order'>> = {
  name_error: 'name',
  EmailAddress_error: 'EmailAddress',
  Subject_error: 'Subject',
  cfComments_error: 'cfComments',
};

/** What the legacy `order` field's placeholder said, and the only field that is optional. */
export const OPTIONAL_PLACEHOLDER = 'Optional';
